<template>
    <modal :showing="show" :large="false">
      <d-card-header class="inner-head border-bottom">
        <h6 class="inner-head__heading m-0">Informations complémentaires</h6>
        <div class="closeFeature" @click="closeModal"></div>
      </d-card-header>
      <d-card-body>
        <div class="py-2 px-3 d-flex flex-wrap align-items-center">
          <div class="col-12 col-lg-6">
            Groupe de la convention collective *
          </div>
          <div class="col-12 col-lg-6">
            <d-input type="text" v-model="conventionCollective" />
          </div>
          <div class="col-12 col-lg-6">
            Coefficient du groupe *
          </div>
          <div class="col-12 col-lg-6">
            <d-input type="text" v-model="agreementGroupCoefficient" />
          </div>
          <div class="col-12 col-lg-6">
            Coefficient du salarié *
          </div>
          <div class="col-12 col-lg-6">
            <d-input type="text" v-model="employeeCoefficient" />
          </div>
          <div class="col-12 col-lg-6">
            <div>Valeur du point 1 (V1) *</div>
            <div style="color: gray; font-size: 11px;">(Mettre un point pour la virgule. Exemple : 6.85) </div>
          </div>
          <div class="col-12 col-lg-6">
            <d-input type="text" v-model="v1" />
          </div>
          <div class="col-12 col-lg-6">
            <div>Valeur du point 2 (V2) *</div>
            <div style="color: gray; font-size: 11px;">(Mettre un point pour la virgule. Exemple : 6.85) </div>
          </div>
          <div class="col-12 col-lg-6">
            <d-input type="text" v-model="v2" />
          </div>
          <div class="col-12 col-lg-6">
            <p>Les piéces justificatives pour la reconstitution de carriére à l'embauche ont été apportées</p>
          </div>
          <div class="col-12 col-lg-6">
            <div class="d-inline-flex mr-5">
              <div class="custom-control custom-radio mb-3 ml-3 mr-5">
                <input type="radio" id="yes-supporting-doc" :value="true" name="yes-supporting-doc" v-model="supportingDocument"
                  class="custom-control-input" />
                <label class="custom-control-label" for="yes-supporting-doc">Oui</label>
              </div>
              <div class="custom-control custom-radio mb-3 ml-3">
                <input type="radio" id="no-supporting-doc" :value="false" name="no-supporting-doc" v-model="supportingDocument"
                  class="custom-control-input" />
                <label class="custom-control-label" for="no-supporting-doc">Non</label>
              </div>
            </div>
          </div>
          <div v-if="supportingDocument" class="col-12 col-lg-6">
            Points de la prime de reconstitution de carriére
          </div>
          <div v-if="supportingDocument" class="col-12 col-lg-6">
            <d-input type="text" v-model="primeRecosntitution" />
          </div>
          <div class="col-12 col-lg-6">
            <p>Le salarié bénéficie-t-il d'une prime d'ancienneté?</p>
          </div>
          <div class="col-12 col-lg-6">
            <div class="d-inline-flex mr-5">
              <div class="custom-control custom-radio mb-3 ml-3 mr-5">
                <input type="radio" id="yes-prime" :value="true" name="yes-prime" v-model="isPrimeAnnciennete"
                  class="custom-control-input" />
                <label class="custom-control-label" for="yes-prime">Oui</label>
              </div>
              <div class="custom-control custom-radio mb-3 ml-3">
                <input type="radio" id="no-prime" :value="false" name="no-prime" v-model="isPrimeAnnciennete"
                  class="custom-control-input" />
                <label class="custom-control-label" for="no-prime">Non</label>
              </div>
            </div>
          </div>
          <div v-if="isPrimeAnnciennete" class="col-12 col-lg-6">
            Points de la prime d'ancienneté de carriére
          </div>
          <div v-if="isPrimeAnnciennete" class="col-12 col-lg-6">
            <d-input type="text" v-model="primeAnnciennete" />
          </div>
          <div class="col-12 col-lg-6">
            <p>Le salarié bénéficie-t-il d'une prime différentielle?</p>
          </div>
          <div class="col-12 col-lg-6">
            <div class="d-inline-flex mr-5">
              <div class="custom-control custom-radio mb-3 ml-3 mr-5">
                <input type="radio" id="yes-diff" :value="true" name="yes-diff" v-model="isPrimeDifferentielle"
                  class="custom-control-input" />
                <label class="custom-control-label" for="yes-diff">Oui</label>
              </div>
              <div class="custom-control custom-radio mb-3 ml-3">
                <input type="radio" id="no-diff" :value="false" name="no-diff" v-model="isPrimeDifferentielle"
                  class="custom-control-input" />
                <label class="custom-control-label" for="no-diff">Non</label>
              </div>
            </div>
          </div>
          <div v-if="isPrimeDifferentielle" class="col-12 col-lg-6">
            Points de la prime différentielle de carriére
          </div>
          <div v-if="isPrimeDifferentielle" class="col-12 col-lg-6">
            <d-input type="text" v-model="primeDifferentielle" />
          </div>
        </div>
      </d-card-body>
      <d-card-footer>
        <div class="d-flex justify-content-end">
          <button class="btn btn-primary wizard-btn next-btn" @click="showAddInfo">
            VALIDER
          </button>
        </div>
      </d-card-footer>
    </modal>
  </template>
  
  <script>
  import Modal from '../layout/Modal/Modal';
  
  export default {
    name: 'AdditionalInformationModal',
    components: { Modal },
    props: ["reference"],
    data() {
      return {
        show: false,
        supportingDocument: false,
        isPrimeAnnciennete: false,
        isPrimeDifferentielle: false,
        primeAnnciennete: "",
        primeDifferentielle: "",
        primeRecosntitution: "",
        conventionCollective: "",
        agreementGroupCoefficient: "",
        employeeCoefficient: "",
        v1: "",
        v2: ""
      };
    },
    methods: {
      showAddInfo() {
        let model = {
          supportingDocument : this.supportingDocument,
          conventionCollective: this.conventionCollective,
          agreementGroupCoefficient: this.agreementGroupCoefficient,
          employeeCoefficient: this.employeeCoefficient,
          v1: this.v1,
          v2: this.v2,
          careerReconstitutionPoints: this.primeRecosntitution,
          careerSeniorityPoints: this.primeAnnciennete,
          careerSeniority: this.isPrimeAnnciennete,
          differentialBonusPoints: this.primeDifferentielle,
          differentialBonus: this.isPrimeDifferentielle

        };
        this.$services.contractRequestService.postAdditionalInformation(this.reference, model)
          .then((res) => {
            this.show = false;
            location.reload();
          })
      },
      closeModal() {
        this.show = false;
      },
      openModal() {
        this.show = true;
      },
    },
  };
  </script>
  
  <style scoped>
  </style>
  